"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelectize = require("react-selectize");

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var FormInputField = /*#__PURE__*/function (_React$Component) {
  _inherits(FormInputField, _React$Component);

  _createClass(FormInputField, null, [{
    key: "constants",
    get: function get() {
      return {
        SINGLE_SELECT: 'select-one',
        //Use with FormInputField.component.constants.SINGLE_SELECT
        MULTI_SELECT: 'select-multiple',
        TEXTAREA: 'textarea',
        TEXT: 'text',
        CHECKBOX: 'checkbox'
      };
    }
  }, {
    key: "component",
    get: function get() {
      return FormInputField;
    }
  }]);

  function FormInputField(props) {
    var _this;

    _classCallCheck(this, FormInputField);

    _this = _possibleConstructorReturn(this, (FormInputField.__proto__ || Object.getPrototypeOf(FormInputField)).call(this, props));
    _this.getLabel = _this.getLabel.bind(_assertThisInitialized(_this));
    _this.getPlaceholder = _this.getPlaceholder.bind(_assertThisInitialized(_this));
    _this.getReadOnlyMockup = _this.getReadOnlyMockup.bind(_assertThisInitialized(_this)); // For Multiselects

    if (props.type === FormInputField.component.constants.MULTI_SELECT) {
      _this.state = {
        selectedOptions: props.value.map(function (item) {
          return {
            label: item.name,
            value: item.id
          };
        }),
        options: props.list.map(function (item) {
          return {
            label: item.name,
            value: item.id
          };
        })
      };
    }

    return _this;
  }

  _createClass(FormInputField, [{
    key: "getLabel",
    value: function getLabel() {
      return this.props.label || capitalizeFirstLetter(this.props.name);
    }
  }, {
    key: "getPlaceholder",
    value: function getPlaceholder(t) {
      return "".concat(t('Enter a value for'), ": ").concat(this.getLabel());
    }
  }, {
    key: "getEditableInputFieldMockup",
    value: function getEditableInputFieldMockup() {
      var _this2 = this;

      var formField,
          error = '',
          hasError = false,
          _this$props = this.props,
          type = _this$props.type,
          value = _this$props.value,
          name = _this$props.name,
          onChange = _this$props.onChange,
          errors = _this$props.errors,
          allowAll = _this$props.allowAll,
          readOnly = _this$props.readOnly,
          list = _this$props.list,
          t = _this$props.t,
          placeholder = this.getPlaceholder(t);

      if (errors) {
        hasError = Object.keys(this.props.errors).indexOf(this.props.name) !== -1;

        if (hasError) {
          error = this.props.errors[this.props.name].map(function (errorMsg) {
            return t(errorMsg);
          });
          error = error.join(', ');
        }
      }

      var onValuesChange = function onValuesChange(values) {
        _this2.setState({
          selectedOptions: values
        }); // Transform values to an 'event'-like object,
        // so that no change in onChange callback is needed.


        onChange.call(null, {
          target: {
            name: name,
            type: type,
            selectedOptions: values.map(function (item) {
              return {
                value: item.value
              };
            })
          }
        });
      };

      var onRemoveItem = function onRemoveItem(item) {
        var selectedOptions = _this2.state.selectedOptions.filter(function (option) {
          return option.value !== item.value;
        });

        _this2.setState({
          selectedOptions: selectedOptions
        });

        onChange.call(null, {
          target: {
            name: name,
            type: type,
            selectedOptions: selectedOptions
          }
        });
      };

      var renderValue = function renderValue(item) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "tag-item"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "tag-item__remove",
          onClick: onRemoveItem.bind(this, item)
        }), /*#__PURE__*/_react.default.createElement("span", null, item.label));
      };

      switch (type) {
        case FormInputField.component.constants.TEXTAREA:
          formField = /*#__PURE__*/_react.default.createElement("label", {
            className: "input ".concat(hasError ? 'error' : '', " ").concat(readOnly ? 'read-only' : '')
          }, this.getLabel(), /*#__PURE__*/_react.default.createElement("span", {
            className: "input__wrapper"
          }, /*#__PURE__*/_react.default.createElement("textarea", {
            name: name,
            value: value,
            placeholder: placeholder,
            onChange: onChange
          })), /*#__PURE__*/_react.default.createElement("span", {
            className: "input__error"
          }, error));
          break;

        case FormInputField.component.constants.CHECKBOX:
          formField = /*#__PURE__*/_react.default.createElement("div", {
            className: "checkbox"
          }, /*#__PURE__*/_react.default.createElement("input", {
            id: name,
            name: name,
            onChange: onChange,
            checked: !!value,
            type: "checkbox"
          }), /*#__PURE__*/_react.default.createElement("label", {
            className: "checkbox__label",
            htmlFor: name
          }, this.getLabel()));
          break;

        case FormInputField.component.constants.SINGLE_SELECT:
          value = value === undefined ? -1 : value;
          formField = /*#__PURE__*/_react.default.createElement("label", {
            className: "select ".concat(hasError ? 'error' : '', " ").concat(readOnly ? 'read-only' : '')
          }, this.getLabel(), /*#__PURE__*/_react.default.createElement("span", {
            className: "select__wrapper"
          }, /*#__PURE__*/_react.default.createElement("select", {
            name: name,
            value: value,
            onChange: onChange
          }, /*#__PURE__*/_react.default.createElement("option", {
            disabled: true,
            value: "-1"
          }, t('Please choose')), //TODO: Is allowAll really ever needed? If not, remove it. --> Yes is needed in the
          //project list (/projects) but if there is a better/simple solution we can do it.
          allowAll ? /*#__PURE__*/_react.default.createElement("option", {
            key: "".concat(name, "-all"),
            value: ''
          }, t('All')) : '', list.map(function (item) {
            return /*#__PURE__*/_react.default.createElement("option", {
              key: item.id,
              value: item.id
            }, item.name);
          }))), /*#__PURE__*/_react.default.createElement("span", {
            className: "select__error"
          }, error));
          break;

        case FormInputField.component.constants.MULTI_SELECT:
          formField = /*#__PURE__*/_react.default.createElement("label", {
            className: "input ".concat(hasError ? 'error' : '', " ").concat(readOnly ? 'read-only' : '')
          }, this.getLabel(), /*#__PURE__*/_react.default.createElement("span", {
            className: "input__wrapper"
          }, /*#__PURE__*/_react.default.createElement(_reactSelectize.MultiSelect, {
            name: name,
            renderValue: renderValue,
            onValuesChange: onValuesChange,
            values: this.state.selectedOptions,
            options: this.state.options
          })), /*#__PURE__*/_react.default.createElement("span", {
            className: "input__error"
          }, error));
          break;

        default:
          formField = /*#__PURE__*/_react.default.createElement("label", {
            className: "input ".concat(hasError ? 'error' : '', " ").concat(readOnly ? 'read-only' : '')
          }, this.getLabel(), /*#__PURE__*/_react.default.createElement("span", {
            className: "input__wrapper"
          }, /*#__PURE__*/_react.default.createElement("input", {
            type: type,
            name: name,
            value: value,
            placeholder: placeholder,
            readOnly: readOnly,
            onChange: onChange
          })), /*#__PURE__*/_react.default.createElement("span", {
            className: "input__error"
          }, error));
      }

      return formField;
    }
  }, {
    key: "getReadOnlyMockup",
    value: function getReadOnlyMockup(type) {
      var t = this.props.t;
      var valueMarkup, tmpValue;

      switch (type) {
        case FormInputField.component.constants.CHECKBOX:
          valueMarkup = /*#__PURE__*/_react.default.createElement("span", {
            className: "input__value"
          }, this.props.value ? t('yes') : t('No'));
          break;

        case FormInputField.component.constants.SINGLE_SELECT:
          tmpValue = this.props.value ? this.props.relatedValue : '-';
          valueMarkup = /*#__PURE__*/_react.default.createElement("span", {
            className: "input__value"
          }, tmpValue);
          break;

        case FormInputField.component.constants.MULTI_SELECT:
          tmpValue = this.props.value && this.props.value.length > 0 ? this.props.value.map(function (item) {
            return item.name;
          }).join(', ') : '-';
          valueMarkup = /*#__PURE__*/_react.default.createElement("span", {
            className: "input__value"
          }, tmpValue);
          break;

        default:
          tmpValue = this.props.value ? this.props.value : '-';
          valueMarkup = /*#__PURE__*/_react.default.createElement("span", {
            className: "input__value",
            title: tmpValue
          }, tmpValue);
      }

      return /*#__PURE__*/_react.default.createElement("label", {
        className: "input input--read-only-mock"
      }, this.getLabel(), valueMarkup);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      //eslint-disable-line
      if (this.props.type === FormInputField.component.constants.MULTI_SELECT) {
        this.setState({
          selectedOptions: nextProps.value.map(function (item) {
            return {
              label: item.name,
              value: item.id
            };
          }),
          options: nextProps.list.map(function (item) {
            return {
              label: item.name,
              value: item.id
            };
          })
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'form-field ' + (this.props.isCell && 'cell')
      }, this.props.isEditable ? this.getEditableInputFieldMockup() : this.getReadOnlyMockup(this.props.type));
    }
  }]);

  return FormInputField;
}(_react.default.Component);

FormInputField.propTypes = {
  t: _propTypes.default.func.isRequired,
  isEditable: _propTypes.default.bool.isRequired,
  type: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  readOnly: _propTypes.default.bool,
  value: _propTypes.default.any,
  onChange: _propTypes.default.func.isRequired,
  list: _propTypes.default.array,
  relatedValue: _propTypes.default.string,
  allowAll: _propTypes.default.bool,
  errors: _propTypes.default.object,
  isCell: _propTypes.default.bool,
  label: _propTypes.default.string
};
FormInputField.defaultProps = {
  type: FormInputField.component.constants.TEXT,
  placeholder: '',
  isCell: true
};

var _default = (0, _translate.default)(FormInputField);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-input-field/index.js
// module id = 105
// module chunks = 0